

export const distanceBetweenCoordinates = function(coordsA, coordsB){
  var a = coordsB[0] - coordsA[0]
  var b = coordsB[1] - coordsA[1]

  return Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)) 
}